import { computed, ref } from 'vue';
import { defineStore } from 'pinia';
import emitter, { EVENTS } from 'plugins/store/events';
import { pinia } from 'plugins/store/index';

// available colors
export const cursorColorDefault = 'black';
export const cursorColorAccent = '#ff3377';
export const cursorColorOther = '#00664f';

// for typing purpose, or if we wanna change the cursor with some random color from these ->
export const cursorColors = <const>[
  cursorColorDefault,
  cursorColorAccent,
  cursorColorOther
];

interface ICursor extends Obj {
  color: typeof cursorColors[number];
}

const useStore = defineStore('cursor', () => {
  const state = ref<ICursor>({
    color: cursorColorDefault
  });

  //Actions
  // Pass specific color name from our colors array
  const changeColor = (value:typeof cursorColors[number]) => {
    state.value.color = value;
  }

  // do we prefer something like this ? ->
  const resetColor = () => {
    state.value.color = cursorColorDefault;
  }
  
  const setColorAccent = () => {
    state.value.color = cursorColorAccent;
  }

  const setColorOther = () => {
    state.value.color = cursorColorOther;
  }

  const updateCursor = () => {
    setTimeout(() => {
      emitter.emit(EVENTS.CURSOR_UPDATE);
    }, 500);
  }

  return {
    state,

    //getters
    color: computed( () => state.value.color),

    //actions
    changeColor,
    resetColor,
    setColorAccent,
    setColorOther,
    updateCursor
  }
});

export const store = useStore(pinia);
export default store;
